<template>
  <div class="page-new-layout">
    <div
      :class="`page-header ${themeColor}`"
      :style="`background:${headerBkgColor};box-shadow: ${headerBoxShadow};`"
    >
      <div :class="`header-left ${type}`">
        <span class="header-left-title">{{ title }}</span>
      </div>
      <div :class="`header-middle ${type}`">
        <div
          :class="`middle-title  ${themeColor}`"
          :style="'background:' + headerMiddleBkgColor"
        >
          <el-tooltip
            class="item"
            effect="dark"
            :content="currentTitle"
            placement="right"
          >
            <span>{{ currentTitle }}</span>
          </el-tooltip>
        </div>
      </div>
      <div
        :class="`header-right ${type}`"
        :style="type === 'video' ? (fold ? 'right: 50px' : 'right: 195px') : ''"
      >
        <div
          class="mode-icon"
          @click="handleThemeSwitch"
          style="cursor: pointer"
        >
          <template v-if="themeColor === 'dark'">
            <img src="@/assets/images/project/theme-icon-sunny.png" />
            <span>浅色模式</span>
          </template>
          <template v-else>
            <img src="@/assets/images/project/theme-icon-moon.png" />
            <span>深色模式</span>
          </template>
        </div>
        <div @click="handleFoldClick" v-if="needFolder" class="img-close">
          <img
            v-if="themeColor === 'dark'"
            src="@/assets/images/project/close.png"
          />
          <img v-else src="@/assets/images/project/close-black.png" />
        </div>
      </div>
    </div>
    <div class="page-body" :style="`background:${bodyBkgColor};`">
      <slot name="body-left"></slot>
      <slot name="body-main"></slot>
      <slot name="body-right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    currentTitle: {
      type: String,
      default: ""
    },
    fold: {
      type: Boolean,
      default: false
    },
    needFolder: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: "video"
    }
  },
  computed: {
    headerBkgColor() {
      const { theme } = this.$store.getters;
      return theme === "dark" ? "#2F3133" : "#EEEEEE";
    },
    bodyBkgColor() {
      const { theme } = this.$store.getters;
      return theme === "dark" ? "#141313" : "#F7F7F7";
    },
    themeColor() {
      return this.$store.getters.theme;
    },
    headerMiddleBkgColor() {
      const { theme } = this.$store.getters;
      return theme === "dark" ? "#292626" : "#FFFFFF";
    },
    headerBoxShadow() {
      const { theme } = this.$store.getters;
      return theme === "dark"
        ? "0px 4px 10px 0px rgba(0, 0, 0, 0.5)"
        : "0px 4px 10px 0px rgba(0, 0, 0, 0.1)";
    }
  },
  methods: {
    handleFoldClick() {
      this.$emit("onClickFold");
    },
    handleThemeSwitch() {
      const theme = this.themeColor === "dark" ? "light" : "dark";
      this.$store.dispatch("setTheme", theme);
    }
  }
};
</script>

<style lang="less" scoped>
.page-new-layout {
  width: 100%;
  height: 100%;
  min-width: 1200px;
}
.page-header {
  width: 100%;
  margin: auto;
  flex: 0 0 auto;
  height: 72px;
  background: rgba(47, 49, 51, 1);
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  .header-left {
    &.article {
      flex: 1;
      padding-left: 40px;
    }
    &.video {
      position: absolute;
      left: 40px;
      max-width: 33%;
    }
    height: 72px;
    display: flex;
    align-items: center;
    &-title {
      @media only screen and (max-width: 1440px) {
        max-width: 170px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      margin-left: 5px;
    }
  }
  .header-middle {
    &.article {
      width: 960px;
    }
    text-align: center;
    display: flex;
    justify-content: center;
    .middle-title {
      height: 39px;
      width: fit-content;
      max-width: 400px;
      min-width: 189px;
      background: rgba(41, 38, 38, 1);
      border-radius: 20px;
      text-overflow: ellipsis;
      span {
        display: inline-block;
        text-align: center;
        width: 100%;
        line-height: 39px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #0fc700;
        text-overflow: ellipsis;
        overflow: hidden;
        padding: 0px 10px;
        white-space: nowrap;
      }
    }
  }
  .header-right {
    &.article {
      flex: 1;
    }
    &.video {
      position: absolute;
    }
    height: 72px;
    font-size: 22px;
    cursor: pointer;
    display: flex;
    align-items: center;
    i {
      flex-shrink: 0;
    }
    & .mode-icon {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      line-height: 22px;
      display: flex;
      align-items: center;
      margin-right: 20px;
    }
    span {
      margin-left: 5px;
    }
    .img-close {
      width: 30px;
      height: 25px;
      cursor: pointer;
      img {
        width: 22px;
        height: 17px;
      }
    }
  }
}
.page-body {
  display: flex;
  justify-content: center;
  height: calc(100vh - 72px);
  max-height: calc(100vh - 72px);
  width: 100%;
  min-height: 0;
}
.light {
  color: #161718;
}
.dark {
  color: #fff;
}
</style>
